const FAVORITES = {
    name: "Favorites",
    description: "",
    scoringKeys: [{
        name: "Favorite",
        description: "",
        upperLimit: 1,
        lowerLimitExclusive: 0.9
    }, {
        name: "Like",
        description: "",
        upperLimit: 0.9,
        lowerLimitExclusive: 0.0
    }, {
        name: "Dislike",
        description: "",
        upperLimit: 0.0
    }]
}

const RANK = {
    name: "Rank",
    description: "",
    scoringKeys: [{
        name: "Rank",
        description: "",
        upperLimit: 1
    }]
}

const CHECKLIST = {
    name: "Checklist",
    description: "",
    scoringKeys: [
        {
            name: "Complete",
            description: "",
            upperLimit: 1,
            lowerLimitExclusive: 0.0
        },
        {
            name: "In progress",
            description: "",
            upperLimit: 0
        }]
}

const BALLOT_BOX_CHECK = {
    name: "Ballot Box (Check)",
    description: "",
    scoringKeys: [
        {
            name: "\u2611",
            description: "",
            upperLimit: 1,
            lowerLimitExclusive: 0.0
        },
        {
            name: "\u2610",
            description: "",
            upperLimit: 0
        }]
}

const BALLOT_BOX_CROSS = {
    name: "Ballot Box",
    description: "",
    scoringKeys: [
        {
            name: "\u2612",
            description: "",
            upperLimit: 1,
            lowerLimitExclusive: 0.0
        },
        {
            name: "\u2610",
            description: "",
            upperLimit: 0
        }]
}

const THUMBS = {
    name: "Thumbs",
    description: "",
    scoringKeys: [
        {
            name: "\uD83D\uDC4D",
            description: "",
            upperLimit: 1,
            lowerLimitExclusive: 0.0
        },
        {
            name: "\uD83D\uDC4E",
            description: "",
            upperLimit: 0
        }]
}

const STAR = '\u2605';
const EMPTY_STAR = '\u2606';
const FIVE_STAR = {
    name: "Five Star",
    description: "",
    scoringKeys: [{
        name: STAR.repeat(5),
        description: "",
        upperLimit: 1,
        lowerLimitExclusive: 0.8
    }, {
        name: STAR.repeat(4) + EMPTY_STAR.repeat(1),
        description: "",
        upperLimit: 0.8,
        lowerLimitExclusive: 0.6
    }, {
        name: STAR.repeat(3) + EMPTY_STAR.repeat(2),
        description: "",
        upperLimit: 0.6,
        lowerLimitExclusive: 0.4
    }, {
        name: STAR.repeat(2) + EMPTY_STAR.repeat(3),
        description: "",
        upperLimit: 0.4,
        lowerLimitExclusive: 0.2
    }, {
        name: STAR.repeat(1) + EMPTY_STAR.repeat(4),
        description: "",
        upperLimit: 0.2,
        lowerLimitExclusive: 0
    }, {
        name: EMPTY_STAR.repeat(5),
        description: "",
        upperLimit: 0
    }]
}

const HEART = '\u2764\ufe0f '
const FIVE_HEARTS = {
    name: "Hearts",
    description: "",
    scoringKeys: [{
        name: HEART.repeat(5),
        description: "",
        upperLimit: 1,
        lowerLimitExclusive: 0.8
    }, {
        name: HEART.repeat(4),
        description: "",
        upperLimit: 0.8,
        lowerLimitExclusive: 0.6
    }, {
        name: HEART.repeat(3),
        description: "",
        upperLimit: 0.6,
        lowerLimitExclusive: 0.4
    }, {
        name: HEART.repeat(2),
        description: "",
        upperLimit: 0.4,
        lowerLimitExclusive: 0.2
    }, {
        name: HEART.repeat(1),
        description: "",
        upperLimit: 0.2,
        lowerLimitExclusive: 0
    }, {
        name: "",
        description: "",
        upperLimit: 0
    }]
}

const NEGATIVE_IMPACT = {
    name: "Negative Impact",
    description: "",
    scoringKeys: [{
        name: "None",
        description: "",
        upperLimit: 1,
        lowerLimitExclusive: 0.75
    }, {
        name: "Minimal",
        description: "",
        upperLimit: 0.75,
        lowerLimitExclusive: 0.5
    }, {
        name: "Noticeable",
        description: "",
        upperLimit: 0.5,
        lowerLimitExclusive: 0.25
    }, {
        name: "High",
        description: "",
        upperLimit: 0.25,
        lowerLimitExclusive: 0
    },
        {
            name: "Extreme",
            description: "",
            upperLimit: 0.0
        }]
}

const LETTER_GRADE_DETAILED = {
    name: "Letter Grade (detailed)",
    description: "",
    scoringKeys: [{
        name: "A+",
        description: "",
        upperLimit: 1,
        lowerLimitExclusive: 0.96
    }, {
        name: "A",
        description: "",
        upperLimit: 0.96,
        lowerLimitExclusive: 0.92
    }, {
        name: "A-",
        description: "",
        upperLimit: 0.92,
        lowerLimitExclusive: 0.89
    }, {
        name: "B+",
        description: "",
        upperLimit: 0.89,
        lowerLimitExclusive: 0.86
    }, {
        name: "B",
        description: "",
        upperLimit: 0.86,
        lowerLimitExclusive: 0.82
    }, {
        name: "B-",
        description: "",
        upperLimit: 0.82,
        lowerLimitExclusive: 0.79
    }, {
        name: "C+",
        description: "",
        upperLimit: 0.79,
        lowerLimitExclusive: 0.76
    }, {
        name: "C",
        description: "",
        upperLimit: 0.76,
        lowerLimitExclusive: 0.72
    }, {
        name: "C-",
        description: "",
        upperLimit: 0.72,
        lowerLimitExclusive: 0.69
    }, {
        name: "D+",
        description: "",
        upperLimit: 0.69,
        lowerLimitExclusive: 0.66
    }, {
        name: "D",
        description: "",
        upperLimit: 0.66,
        lowerLimitExclusive: 0.62
    }, {
        name: "D-",
        description: "",
        upperLimit: 0.62,
        lowerLimitExclusive: 0.59
    }, {
        name: "F",
        description: "",
        upperLimit: 0.59
    }]
}

const GPA_DETAILED = {
    name: "GPA (detailed)",
    description: "",
    scoringKeys: [{
        name: "4.33",
        description: "",
        upperLimit: 1,
        lowerLimitExclusive: 0.96
    }, {
        name: "4.00",
        description: "",
        upperLimit: 0.96,
        lowerLimitExclusive: 0.92
    }, {
        name: "3.67",
        description: "",
        upperLimit: 0.92,
        lowerLimitExclusive: 0.89
    }, {
        name: "3.33",
        description: "",
        upperLimit: 0.89,
        lowerLimitExclusive: 0.86
    }, {
        name: "3.00",
        description: "",
        upperLimit: 0.86,
        lowerLimitExclusive: 0.82
    }, {
        name: "2.67",
        description: "",
        upperLimit: 0.82,
        lowerLimitExclusive: 0.79
    }, {
        name: "2.33",
        description: "",
        upperLimit: 0.79,
        lowerLimitExclusive: 0.76
    }, {
        name: "2.00",
        description: "",
        upperLimit: 0.76,
        lowerLimitExclusive: 0.72
    }, {
        name: "1.67",
        description: "",
        upperLimit: 0.72,
        lowerLimitExclusive: 0.69
    }, {
        name: "1.33",
        description: "",
        upperLimit: 0.69,
        lowerLimitExclusive: 0.66
    }, {
        name: "1.00",
        description: "",
        upperLimit: 0.66,
        lowerLimitExclusive: 0.62
    }, {
        name: "0.67",
        description: "",
        upperLimit: 0.62,
        lowerLimitExclusive: 0.59
    }, {
        name: "0.00",
        description: "",
        upperLimit: 0.59
    }]
}

const LETTER_GRADE = {
    name: "Letter Grade",
    description: "",
    scoringKeys: [{
        name: "A",
        description: "",
        upperLimit: 1,
        lowerLimitExclusive: 0.89
    }, {
        name: "B",
        description: "",
        upperLimit: 0.89,
        lowerLimitExclusive: 0.79
    }, {
        name: "C",
        description: "",
        upperLimit: 0.79,
        lowerLimitExclusive: 0.69
    }, {
        name: "D",
        description: "",
        upperLimit: 0.69,
        lowerLimitExclusive: 0.59
    }, {
        name: "F",
        description: "",
        upperLimit: 0.59
    }]
}

const GPA = {
    name: "GPA",
    description: "",
    scoringKeys: [{
        name: "4.0",
        description: "",
        upperLimit: 1,
        lowerLimitExclusive: 0.89
    }, {
        name: "3.0",
        description: "",
        upperLimit: 0.89,
        lowerLimitExclusive: 0.79
    }, {
        name: "2.0",
        description: "",
        upperLimit: 0.79,
        lowerLimitExclusive: 0.69
    }, {
        name: "1.0",
        description: "",
        upperLimit: 0.69,
        lowerLimitExclusive: 0.59
    }, {
        name: "0.0",
        description: "",
        upperLimit: 0.59
    }]
}


export default class PresetScoringKeys {
    static readonly PRESET_SCORING_KEYS = {
        FAVORITES: FAVORITES,
        RANK: RANK,
        CHECKLIST: CHECKLIST,
        BALLOT_BOX_CHECK: BALLOT_BOX_CHECK,
        BALLOT_BOX_CROSS: BALLOT_BOX_CROSS,
        THUMBS: THUMBS,
        FIVE_STAR: FIVE_STAR,
        HEARTS: FIVE_HEARTS,
        NEGATIVE_IMPACT: NEGATIVE_IMPACT,
        LETTER_GRADE: LETTER_GRADE,
        LETTER_GRADE_DETAILED: LETTER_GRADE_DETAILED,
        GPA: GPA,
        GPA_DETAILED: GPA_DETAILED,


    }

}

